import { ROUTEPATHS } from "../constants";

export const getProgramUrl = (id) => {
  return ROUTEPATHS.employee.charities.replace(":programId", id);
};
